const addressOptions = [
  { value: 'Owner occupier', label: 'Owner occupier' },
  {
    value:
      'Tenant - Local Authority/Arms Length Management Organisation/registered social housing provider',
    label:
      'Tenant - Local Authority/Arms Length Management Organisation/registered social housing provider',
  },
  { value: 'Tenant - private landlord', label: 'Tenant - private landlord' },
  { value: 'Living with family', label: 'Living with family' },
  { value: 'Living with friends', label: 'Living with friends' },
  {
    value: 'University or College accommodation',
    label: 'University or College accommodation',
  },
  {
    value: 'ACCOMMODATION tied to job (including Armed Forces)',
    label: 'ACCOMMODATION tied to job (including Armed Forces)',
  },
  { value: 'Mobile ACCOMMODATION', label: 'Mobile ACCOMMODATION' },
  {
    value: 'Care Home Services without Nursing',
    label: 'Care Home Services without Nursing',
  },
  {
    value: 'Care Home Services with Nursing',
    label: 'Care Home Services with Nursing',
  },
  {
    value:
      'Specialist Housing (with suitable adaptations to meet impairment needs and support to live independently)',
    label:
      'Specialist Housing (with suitable adaptations to meet impairment needs and support to live independently)',
  },
  { value: 'Rough sleeper', label: 'Rough sleeper' },
  { value: 'Squatting', label: 'Squatting' },
  {
    value: 'Sofa surfing (sleeps on different friends floor each night)',
    label: 'Sofa surfing (sleeps on different friends floor each night)',
  },
  {
    value: 'Staying with friends/family as a short term guest',
    label: 'Staying with friends/family as a short term guest',
  },
  {
    value: 'Bed and breakfast ACCOMMODATION to prevent or relieve homelessness',
    label: 'Bed and breakfast ACCOMMODATION to prevent or relieve homelessness',
  },
  {
    value: 'Sleeping in a night shelter',
    label: 'Sleeping in a night shelter',
  },
  {
    value: 'Hostel to prevent or relieve homelessness',
    label: 'Hostel to prevent or relieve homelessness',
  },
  {
    value: 'Temporary housing to prevent or relieve homelessness',
    label: 'Temporary housing to prevent or relieve homelessness',
  },
  { value: 'Admitted PATIENT settings', label: 'Admitted PATIENT settings' },
  { value: 'Criminal justice settings', label: 'Criminal justice settings' },
  { value: 'Other (not listed)', label: 'Other (not listed)' },
];

export default addressOptions;
